export const MaintenanceStatus = {
    Upcoming: 1,
    Due: 2,
    Overdue: 3,
    Completed: 4,

    get(status) {
        return this.all().find(x => x.value === status);
    },
    all() {
        return [
            {value: MaintenanceStatus.Upcoming, translationKey: 'maintenance.status.upcoming'},
            {value: MaintenanceStatus.Due, translationKey: 'maintenance.status.due'},
            {value: MaintenanceStatus.Overdue, translationKey: 'maintenance.status.overdue'},
            {value: MaintenanceStatus.Completed, translationKey: 'maintenance.status.completed'},
        ];
    }
};